import { events, track } from 'src/analytics';

export function trackPostCheckoutHdyhau(answer: string, answerDetail?: string) {
  return track(events.post_checkout_hdyhau, {
    action: 'hdyhau',
    label: answer,
    detail: answerDetail,
  });
}
